import { z } from "zod";
import createTreezorDocumentUploadForUser from "./createTreezorDocumentUploadForUser.js";

export default {
  params: z.object({
    memberInvitationId: z.string(),
  }),
  response: createTreezorDocumentUploadForUser.response,
};
